<template>
  <div class="promo-banner">
    <div class="promo-content">
      <div class="promo-icon">
         <img src="@/assets/logo/coupon-icon.png" alt="Coupon" width="23">
      </div>
      <div class="promo-text">
        <small>{{ $t("promo_code_label") }}</small>
        <p>{{promoLabel}}</p>
      </div>
    </div>
    <button class="close-btn" @click="$emit('closeDiscountCouponBanner')">
      <img src="../assets/logo/coupon-close-btn.png" alt="close" class="close-btn"/>
    </button>
  </div>
</template>

<script>
export default {
  name: "PromoBanner",
  props: {
    promoLabel: {
      type: String
    }
  }
};
</script>

<style scoped>
.promo-banner {
  background-color: #29B6F61A;
  color: #020076;
  align-items: center;
  justify-content: space-between;
  border-radius: 12px;
  padding: 10px 16px;
  max-width: 480px;
  font-family: "Inter", sans-serif;
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 100%;
  min-width: 100%;
}

/* Left content */
.promo-content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.promo-icon {
  margin-right: 10px;
  font-size: 16px;
}
.promo-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* ensures left alignment */
  text-align: left;
}
.promo-text small {
  display: block;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.promo-text p {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
}

/* Close button */
.close-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: #020076; /* text color */
}

/* Responsive layout */
@media (max-width: 600px) {
  .promo-banner {
    align-items: flex-start;
    padding: 12px;
  }

  .close-btn {
    align-self: center;
    margin-top: 4px;
    color: #020076; /* text color */
  }

  .promo-text p {
    font-size: 14px;
  }
}
</style>
